import styled, { createGlobalStyle } from "styled-components";
import { mediaMax, mediaMin } from "utils/theme";

export const NavWrapper = styled.div`
  z-index: ${(props) => props.theme.zIndex.nav};

  view-transition-name: navigation;

  ${mediaMin("lg")} {
    position: sticky;
    z-index: ${(props) => props.theme.zIndex.nav};
    top: 0;
  }

  ${mediaMax("lg")} {
    position: fixed;
    bottom: 0;
    left: 0;

    width: 100%;
    height: calc(60px + env(safe-area-inset-bottom, 0));
    min-height: 72px;
    padding: 4px 0 env(safe-area-inset-bottom, 0);
    display: flex;
    align-items: center;

    background: white;
    filter: drop-shadow(
      0 -2px 24px ${(props) => props.theme.colors.tertiary}22
    );
  }
`;

export const AppWrapper = styled.div<{ $hideNavigation?: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 0 0 72px;

  background: ${(props) => props.theme.colors.background};

  font-family: ${(props) => props.theme.fonts.body};

  ${mediaMin("lg")} {
    padding: 0;
  }
`;

const Z_INDEX = 1_000_000;

export const GlobalStyles = createGlobalStyle`
  ::view-transition-old(route-parent) {
    animation: 300ms cubic-bezier(0.4, 0, 0.2, 1) both slide-to-left;
  }

  ::view-transition-new(route-child) {
    animation: 300ms cubic-bezier(0.4, 0, 0.2, 1) both slide-from-right;
  }

  ::view-transition-new(route-parent) {
    animation: 300ms cubic-bezier(0.4, 0, 0.2, 1) both slide-from-left;
  }

  ::view-transition-old(route-child) {
    animation: 300ms cubic-bezier(0.4, 0, 0.2, 1) both slide-to-right;
  }

  ::view-transition-group(navigation) {
    animation: none;
    z-index: ${Z_INDEX + 1};
  }

  ::view-transition-group(route-parent) {
    z-index: ${Z_INDEX - 1};
  }

  ::view-transition-group(route-child) {
    z-index: ${Z_INDEX};
  }

  @keyframes slide-from-right {
    from {
      transform: translateX(100%);
    }
  }

  @keyframes slide-to-left {
    to {
      transform: translateX(-24px);
      filter: brightness(0.3);
    }
  }

  @keyframes slide-to-right {
    to {
      transform: translateX(100%);
    }
  }

  @keyframes slide-from-left {
    from {
      transform: translateX(-24px);
      filter: brightness(0.3);
    }
  }
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  flex: 1 1 auto;
  overflow: hidden;

  ${mediaMin("lg")} {
    padding: 48px;
    gap: 96px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

export const Footer = styled.footer`
  --padding-x: 16px;

  position: relative;
  padding: 0 var(--padding-x);
  max-width: 576px;
  margin: 0 auto;

  ${mediaMax("lg")} {
    padding: 24px var(--padding-x);
  }
`;
